import getSlug from 'speakingurl';

/**
 * Simple util method to keep our slug generation consistent
 * @param {string} input The string to generate a slug for
 * @returns {string} A slug-friendly version of the input
 */
export default function slugger(input) {
  return getSlug(input === '' ? '_' : input, { maintainCase: true });
}



// WEBPACK FOOTER //
// ./src/slugger.js